import {useEffect, type RefObject} from 'react';

export function useHashTracker(containerRef: RefObject<HTMLElement | null>): void {
	useEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		const observer = new IntersectionObserver(
			entries => {
				const visible = entries.filter(e => e.isIntersecting);
				if (visible.length === 0) return;

				const topmost = visible.reduce((a, b) =>
					a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? a : b
				);

				const id = topmost.target.id;
				if (id && window.location.hash !== `#${id}`) {
					window.history.replaceState(null, '', `#${id}`);
				}
			},
			{root: null, threshold: 0.5}
		);

		const items = container.querySelectorAll('[id]');
		items.forEach(el => observer.observe(el));

		return () => observer.disconnect();
	}, [containerRef]);
}
